import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PasswordType } from '@app/shared/types/password-type';

@Component({
  selector: 'app-toggle-password-visibility',
  templateUrl: './toggle-password-visibility.component.html',
  styleUrls: ['./toggle-password-visibility.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TogglePasswordVisibilityComponent {
  @Input() public inputType: PasswordType = 'password';
  @Output() public inputTypeChange = new EventEmitter<PasswordType>();

  public get isTypePassword(): boolean {
    return this.inputType === 'password';
  }

  public toggle(): void {
    this.inputType = this.isTypePassword ? 'text' : 'password';
    this.inputTypeChange.emit(this.inputType);
  }
}
